import Icon from '../Icon'

Icon.register({
  'whatsapp': {
    width: 14,
    height: 14,
    paths: [
      {
        d: 'M11.9,2.0125 C10.5875,0.7 8.925,0 7,0 C3.2375,0 0.0875,3.15 0.0875,6.9125 C0.0875,8.1375 0.4375,9.3625 1.05,10.4125 L0,14 L3.675,13.0375 C4.725,13.5625 5.8625,13.9125 7,13.9125 L7,13.9125 L7,13.9125 C10.85,13.9125 13.9125,10.7625 13.9125,7 C14,5.075 13.2125,3.325 11.9,2.0125 Z M10.4125,9.45 C10.2375,9.8875 9.5375,10.2375 9.275,10.2375 C9.0125,10.325 8.1375,10.2375 7.175,9.8 C5.425,9.0125 4.2875,7.2625 4.2,7.175 C4.1125,7.0875 3.5,6.2125 3.5,5.425 C3.5,4.6375 3.9375,4.1125 4.1125,3.9375 C4.4625,3.5875 5.1625,3.675 5.3375,4.025 C5.425,4.375 5.775,5.25 5.8625,5.3375 C5.95,5.425 5.95,5.775 5.6875,5.95 C5.6,5.95 5.1625,6.3 5.3375,6.5625 C5.425,6.7375 5.775,7.2625 6.3,7.7875 C7,8.4 7.525,8.575 7.7,8.6625 C7.875,8.75 7.9625,8.75 8.05,8.575 C8.1375,8.4875 8.4875,8.05 8.575,7.875 C8.6625,7.7 8.8375,7.7 8.925,7.7875 C9.0125,7.875 9.975,8.225 10.15,8.3125 C10.325,8.4875 10.5,8.4875 10.5,8.575 C10.5875,8.6625 10.5875,9.0125 10.4125,9.45 Z'
      }
    ],
    polygons: []
  }
})
